<div class="overlay">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  <span class="message" *ngIf="message"> {{ message }} </span>
</div>
